import styled from 'styled-components';

export const ForgotPasswordPageStyled = styled.div`
  background-color: #f4f3f3;

  .container-header {
    min-height: 10vh;
    background: linear-gradient(30deg, #9459d0 0%, #027c8b 50%, #0d4693 100%);
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .imagen {
      text-align: center;

      img {
        max-width: 100%;
        height: auto;
        width: 200px;
      }
    }
  }

  .container-field {
    min-height: 90vh;
    max-width: 100%;
    width: 40%;
    padding-top: 2%;
    margin: 0 auto;

    .row-field {
      padding: 5px 0px 0px 0px;
    }
  }

  .form-control:focus,
  .form-select:focus {
    border-color: #9459d0;
    box-shadow: 0 0 0 0.25rem rgba(128, 0, 128, 0.25);
  }

  /* Responsividade */
  @media (max-width: 1200px) {
    .container-field {
      width: 50%;
    }
  }

  @media (max-width: 992px) {
    .container-field {
      width: 60%;
    }
  }

  @media (max-width: 768px) {
    .container-header {
      min-height: 15vh;
    }

    .container-field {
      width: 80%;
    }

    .imagen img {
      width: 150px;
    }
  }

  @media (max-width: 576px) {
    .container-field {
      width: 90%;
      padding-top: 5%;
    }

    .imagen img {
      width: 120px;
    }
  }
`;
